import React from 'react'

type BrandMarkProps = {
  classes?: string
}

const BrandMark: React.FC<BrandMarkProps> = ({ classes = '' }) => (
  <div className={`brand-wordmark text-3xl ${classes}`} aria-label="KiiOn">
    KiiOn
  </div>
)

export default BrandMark
